import JobCard from "./JobCard";

export default JobCard;